import type { PagingRequest } from '#/api/type'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export interface NoticeConfigItem {
  id: number
  title: string
  content: string
  contentType: number
  displayType: number
  clientType?: string
  clientTypes?: number[]
  imageUrls?: string
  scopeType: number
  customerIds?: number[]
  userIds?: string
  triggerType: number
  priority?: number
  status: number
  startTime: string
  endTime?: string
  createdBy?: string
  createdTime?: string
  updatedBy?: string
  updatedTime?: string
}

export interface NoticeConfigQueryCondition {
  content?: string
  clientTypes?: Array<number | string>
  status?: number
}

export interface NoticeConfigUpsertParams {
  id?: number
  title: string
  content: string
  contentType: number
  displayType: number
  clientTypes?: string[]
  imageUrls?: string
  scopeType: number
  customerIds?: number[]
  userIds?: string
  triggerType: number
  priority?: number
  status: number
  startTime: string
  endTime?: string
}

export const noticeConfigApi = defineApi('operation', ({ prefix }) => {
  function queryNoticeList(params: PagingRequest<NoticeConfigQueryCondition>) {
    const requestParams = {
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
      condition: {
        content: params.condition.content,
        clientTypes: params.condition.clientTypes,
        status: Number(params.condition.status),
      },
    }
    return requestClient
      .post(prefix('sysClientNotice/query'), requestParams)
      .then((res) => ({
        items: (res?.list || []).map((item: any) => {
          return {
            id: Number(item.id),
            title: item.title || '',
            content: item.content || '',
            clientTypes: item.clientTypes || [],
            scopeType: item.scopeType,
            customerIds: item.customerIds?.map(String) || [],
            priority: item.priority,
            status: Number(item.status || 0),
            startTime: item.startTime || '',
            endTime: item.endTime || '',
            createdBy: item.createdBy || '',
            createdTime: item.createdTime || '',
            updatedBy: item.updatedBy || '',
            updatedTime: item.updatedTime || '',
          }
        }),
        total: Number(res?.total || 0),
      }))
  }

  function upsertNotice(params: NoticeConfigUpsertParams) {
    return requestClient.post(prefix('sysClientNotice/upsert'), params)
  }

  return {
    queryNoticeList,
    upsertNotice,
  }
})
